import { proxyNumber } from "@ui";
import { Chip, CopyElement, Hint } from "@ui";
import style from "./TableRow.module.scss";
import cn from "classnames";
import { EOperator } from "@interfaces/operator.enum";
import { KyivstarSvg, LifecellSvg, VodafoneSvg } from "pages/admin/StatisticsPage/svg";
import { IUserPurchaseHistoryRecord } from "@interfaces/admin/userPurchaseHistoryRecord";

export function TableRow({
    data
}: {
    data: IUserPurchaseHistoryRecord
}) {
    return (
        <div className={style.row}>
            <div className={style.cell}>
                <p className={style.date}>
                    {
                        (() => {
                            const [year, month, day] = data.created_at.split("T")[0].split("-")

                            return day + "." + month + "." + year;
                        })()
                    }
                </p>
            </div>
            <div className={style.cell}>
                <CopyElement
                    element={<p className={style.userId}>№{proxyNumber(data)}</p>}
                    copyText={proxyNumber(data)}
                />
            </div>
            <div className={cn(style.cell, "flex gap-[5px] items-center")}>
                {
                    {
                        [EOperator.Kyivstar.toLocaleLowerCase()]: <KyivstarSvg />,
                        [EOperator.Vodafone.toLocaleLowerCase()]: <VodafoneSvg />,
                        [EOperator.lifecell.toLocaleLowerCase()]: <LifecellSvg />,
                    }[data.operator.toLocaleLowerCase()]
                }
                <p className={style.operatorName}>{data.operator}, Ukraine</p>
            </div>
            <div className={style.cell}>
                <div
                    className={cn(
                        "rounded-full text-white py-[8px] px-[20px] text-[13px] leading-[13px] font-semibold",
                        data.tariff === "Silver" && "bg-[#aab3d3]",
                        data.tariff === "Platinum" && "bg-[#c6b164]",
                        data.tariff === "Brilliant" && "bg-[#1E9EEE]"
                    )}
                >{data.tariff}</div>
            </div>
            <div className={style.cell}>
                <Chip
                    text={String(data.day_quantity) + (data.day_quantity === 3 ? " дня" : " днів")}
                    color="blue"
                    size="middle"
                />
            </div>
            <div className={style.cell}>
                <Chip
                    text={"$" + String(data.pay_sum)}
                    color="blue"
                    size="middle"
                />
            </div>
        </div>
    )
}